import React from 'react';
import { StarIcon } from 'lucide-react';
import { GradientCta } from './GradientCta';
import { heroVideo, heroVideoPoster, manualPages } from '../../data/media';
const trustBadges = ['🔒 Biztonságos fizetés', '📧 Azonnali hozzáférés', '🎁 6 bónusz az árban', '📱 100% digitális'];

/** Amíg nincs feltöltve a videó, a kézikönyv első valódi oldala jelenik meg a hero vizuálisaként. */
const heroFallbackImage = heroVideoPoster || manualPages[0];
export function Hero() {
  return <section aria-labelledby="hero-title" className="bg-gradient-to-b from-[#F8EEFB] via-[#FBF0F8] to-[#FCEAF2] pb-10 pt-6 md:pb-14 md:pt-10" data-id="element-119" data-mp="3uhj66zv87muf">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-120" data-mp="3gj1llb0maqgq">
        <p className="inline-flex max-w-full items-center rounded-full border border-lavender-line bg-lavender-soft px-4 py-2 text-[11px] font-extrabold uppercase tracking-[0.08em] text-ink sm:px-6 sm:text-[13px]" data-id="element-121" data-mp="3lgb7igossjzt">
          ✦ Saját idő, saját tér · Azonnali digitális hozzáférés
        </p>

        <h1 id="hero-title" className="mx-auto mt-4 max-w-[22ch] font-display text-[2rem] font-extrabold leading-[1.1] tracking-[-0.03em] text-[#1E1917] [text-wrap:balance] sm:text-[2.6rem] md:max-w-[24ch] md:text-[3rem]" data-id="element-122" data-mp="vdbjxdcmmmsq">
          Adj teret annak, amit érzel —{' '}
          <em className="font-serif font-medium tracking-normal text-coral" data-id="element-123" data-mp="147zlasf2zkc9">
            anélkül, hogy bárkinek el kellene magyaráznod.
          </em>
        </h1>

        <p className="mx-auto mt-4 max-w-xl text-[16px] leading-relaxed text-body md:text-[17px]" data-id="element-124" data-mp="cfqv269v3o84">
          Több mint 150 vezetett művészetterápiás gyakorlat, hogy otthon, napi 10 percben magadra figyelhess. Fejezd ki
          színekkel, rajzzal és írással, ami benned van — akkor is, ha nem tudsz rajzolni.
        </p>

        {/* Fő vizuális blokk */}
        <div className="mx-auto mt-7 w-full max-w-[300px] overflow-hidden rounded-[1.75rem] bg-white shadow-[0_24px_48px_-20px_rgba(74,58,53,0.45)] sm:max-w-[340px]" data-id="element-125" data-mp="1wukc9rrn9ufa">
          {heroVideo ? <video src={heroVideo} poster={heroVideoPoster || undefined} autoPlay muted loop playsInline preload="auto" data-slot="hero-video" className="aspect-[9/16] w-full object-cover" data-id="element-126" data-mp="1rxkaht1tvdtz" /> : <img src={heroFallbackImage} alt="A Művészetterápiás Kézikönyv egyik oldala" data-slot="hero-video" className="aspect-[1/1.414] w-full object-contain" data-id="element-127" data-mp="ufbepq8f9vyr" />}
        </div>

        {/* Csillagok + társadalmi bizonyíték */}
        <div className="mt-5 flex justify-center gap-1 text-gold" aria-label="5 csillag" data-id="element-128" data-mp="6rk2snqsnky0">
          {Array.from({
          length: 5
        }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-129" data-mp="atym18ydkmpt" data-mpi={i} />)}
        </div>
        <p className="mx-auto mt-3 max-w-md text-[16px] leading-relaxed text-body" data-id="element-130" data-mp="fr73167sekph">
          Már több száz ember használja ezt a kézikönyvet a nyugalom és az öngondoskodás pillanataihoz.
        </p>

        

        {/* Fő CTA */}
        <div className="mx-auto mt-5 max-w-xl" data-id="element-131" data-mp="3j6w2ntxaszfs">
          <GradientCta href="#ajanlat" data-id="element-132" data-mp="3o7a06i19wqzk">
            <span data-id="element-133" data-mp="3o68s8mfk0km2">Kérem a saját nyugodt perceimet&nbsp;→</span>
          </GradientCta>
        </div>

        {/* 4 bizalmi jelvény */}
        <ul className="mx-auto mt-5 grid max-w-md grid-cols-2 gap-2.5" data-id="element-134" data-mp="3bpphqgaaqltc">
          {trustBadges.map(label => <li key={label} className="flex items-center justify-center rounded-full border border-lavender-line bg-white px-3 py-2.5 text-[14px] font-semibold leading-tight text-body sm:text-[15px]" data-id="element-135" data-mp="36q35a92al9ll">
              {label}
            </li>)}
        </ul>

        {/* Záró bizalmi sor */}
        <p className="mx-auto mt-6 max-w-md text-[14px] font-semibold leading-relaxed text-body/80 sm:text-[15px]" data-id="element-136" data-mp="2xrhn4f0qfwlc">
          🛡️ 30 napos garancia · 🔒 Biztonságos fizetés · 📧 Azonnali hozzáférés e-mailben
        </p>
      </div>
    </section>;
}